import { ArrowRight } from 'src/components/Icons/ArrowRight'

import type { FooterCTACategory, TrackFooterCTAParams } from './validateFooter'

type SubHeaderProps = {
  title: string
  link: string
  ctaCategory: FooterCTACategory
  onTrackCTA: (params: TrackFooterCTAParams) => void
}

export const SubHeader: React.FC<SubHeaderProps> = ({
  title,
  link,
  ctaCategory,
  onTrackCTA,
}) => {
  return (
    <a
      data-testid="footerSubHeader"
      onClick={() => onTrackCTA({ ctaCategory, ctaName: title })}
      aria-label={`Link de redirecionamento para tela ${title}`}
      href={link}
      className="group text-restructure-white
mobile-heading-title4
tablet-mobile-heading-title4
desktop-heading-title4 inline-flex items-center"
    >
      {title}
      <ArrowRight
        className="hidden group-hover:inline-flex ml-2"
        color="white"
        width={32}
        height={32}
      />
    </a>
  )
}
